import React, { useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { TabView, TabPanel } from 'primereact/tabview';
import { Calendar } from 'primereact/calendar';
import { Row, Col } from 'react-bootstrap';
import { regions, outputTemplates, types, genres, countries, languages, imdbTypes } from '../utilities/Data';
import { MultiSelect } from 'primereact/multiselect';

// Style
import '../styles/justCrawler.css';

// Components
import { Button } from "primereact/button";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from "primereact/dropdown";

const EmptyPage = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [region, setRegion] = useState({ name: 'Worldwide', code: 'us', param: 'search' });
    const [type, setType] = useState('movie');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [genre, setGenre] = useState(null);
    const [country, setCountry] = useState(null);
    const [language, setLanguage] = useState(null);
    const [typeFilter, setTypeFilter] = useState(null);

    const [outputTemplate, setOutputTemplate] = useState({ name: 'IMDB + JustWatch', id: 'imdb_justwatch' });

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const url = process.env.REACT_APP_URL_JUST_CRAWLER;

        if (selectedFile) {
            console.log('ok novo', url)
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('territory', region.code);
            formData.append('territoryParam', region.param);
            formData.append('outputTemplate', outputTemplate.id);
            formData.append('searchType', type);

            try {
                console.log('try');
                setLoading(true);
                const response = await fetch(url, {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                console.log('Arquivo enviado com sucesso!');

                // Process the response as Blob
                const blob = await response.blob();

                // Initiate the download of the file returned by the API
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'output.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.log('Erro ao enviar o arquivo:', error);
            }
        }
    };

    const handleIMDBFiltersSubmit = async (event) => {
        event.preventDefault();

        if (!startDate || !endDate || !typeFilter) {
            alert("Please select both start and end dates and type.");
            return;
        }

        const payload = {
            startDate,
            endDate,
            typeFilter,
            genre,
            country,
            language,
        };

        try {
            console.log("Payload:", payload);
            setLoading(true);

            const response = await fetch(process.env.REACT_APP_URL_IMDB_FILTERS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Error submitting IMDB filters data.");
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'output_imdb.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Failed to submit data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleStandardizeXlsx = async (event) => {
        event.preventDefault();
        const url = process.env.REACT_APP_URL_STANDARDIZE_XLSX;

        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);

            try {
                console.log('try');
                setLoading(true);
                const response = await fetch(url, {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                console.log('Arquivo enviado com sucesso!');

                const blob = await response.blob();

                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'standardized_output.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.log('Erro ao enviar o arquivo:', error);
            }
        }
    };

    return (
        <TabView>
            <TabPanel header="Just Crawler">
                <div className="grid">
                    <div className="col-12">
                        <Accordion activeIndex={-1}>
                            <AccordionTab header="Instructions">
                                <h6>To use the Just Crawler, you need to upload a .xlsx file that contains three specific columns:</h6>
                                <ul>
                                    <li>international-title: This column should contain the international title <br /> of the movie or work you wish to analyze.</li>
                                    <br />
                                    <li>ano: In this column, you should fill in the release year of <br /> the movie if you have that information available.</li>
                                    <br />
                                    <li>imdb: Alternatively to the "year" column, you can use the "imdb" <br /> column to input IMDb codes for the films you want to analyze.</li>
                                </ul>
                                <p><strong>Please ensure that your file meets these criteria as they are essential for <br /> the correct functioning of the Just Crawler.</strong></p>
                                <p><a href="https://vodcore-bucket.s3.us-west-2.amazonaws.com/templates/Template-justcrawler.xlsx" target='_blank' rel="noopener noreferrer" >Download the example template here</a></p>
                            </AccordionTab>
                        </Accordion>

                        <br />

                        <div className="container">
                            <div className="field-territory">
                                <label htmlFor="outputTemplate">
                                    Output:
                                </label>
                                <Dropdown
                                    id="outputTemplate"
                                    style={{ width: '175px' }}
                                    value={outputTemplate}
                                    onChange={(e) => {
                                        setOutputTemplate(e.target.value);
                                    }}
                                    options={outputTemplates}
                                    optionLabel="name"
                                    placeholder="select template..."
                                ></Dropdown>
                            </div>

                            <div className="field-territory" style={{ visibility: outputTemplate.id !== "imdb_justwatch" ? "hidden" : "visible" }}>
                                <label htmlFor="region">
                                    Select Region:
                                </label>
                                <Dropdown
                                    id="territories"
                                    style={{ width: '175px' }}
                                    value={region}
                                    onChange={(e) => {
                                        setRegion(e.target.value);
                                    }}
                                    options={regions}
                                    optionLabel="name"
                                    placeholder="Region"
                                ></Dropdown>
                            </div>

                            <div className="type-dropdown">
                                <label htmlFor="type">
                                    Select Type:
                                </label>
                                <Dropdown
                                    id="type"
                                    style={{ width: '175px' }}
                                    value={type}
                                    onChange={(e) => setType(e.value)}
                                    options={types}
                                    optionLabel="name"
                                    placeholder="Select type"
                                ></Dropdown>
                            </div>

                            <div className="field-territory"
                                style={{ visibility: outputTemplate.id !== "imdb_justwatch" ? "hidden" : "visible", textAlign: 'center' }}
                            >
                            </div>

                        </div>

                        <br />

                        <form onSubmit={handleSubmit}>
                            <input
                                type="file"
                                id="fileInputJustCrawler"
                                placeholder='Choose file'
                                onChange={handleFileChange}
                                accept=".xlsx, .xls"
                            />
                            <br />
                            <br />
                            <Button
                                type="submit"
                                label="Extract"
                                icon="pi pi-save"
                                className="p-button-info mr-2"
                            />
                            {loading ?
                                <ProgressSpinner
                                    style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"
                                />
                                :
                                null
                            }
                        </form>
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="IMDB Filters">
                <div className="container">
                    <Row className="g-3 mb-3">
                        <Col md={4}>
                            <div className="d-flex align-items-center mb-3">
                                <label htmlFor="startDate" style={{ width: '150px' }}>Start Date:</label>
                                <Calendar
                                    id="startDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.value)}
                                    placeholder="Select start date"
                                    dateFormat="dd/mm/yy"
                                    style={{ flex: 1, width: '150px' }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="d-flex align-items-center mb-3">
                                <label htmlFor="typeFilter" style={{ width: '150px' }}>Select Type:</label>
                                <MultiSelect
                                    id="typeFilter"
                                    value={typeFilter}
                                    onChange={(e) => setTypeFilter(e.value)}
                                    options={imdbTypes}
                                    optionLabel="name"
                                    placeholder="Select type"
                                    style={{ flex: 1, width: '150px' }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="d-flex align-items-center mb-3">
                                <label htmlFor="country" style={{ width: '150px' }}>Country of Origin:</label>
                                <MultiSelect
                                    id="country"
                                    value={country}
                                    onChange={(e) => setCountry(e.value)}
                                    options={countries}
                                    optionLabel="name"
                                    placeholder="Select country"
                                    style={{ flex: 1, width: '150px' }}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row className="g-3 mb-3 ml-6">
                        <Col md={4}>
                            <div className="d-flex align-items-center mb-3">
                                <label htmlFor="endDate" style={{ width: '150px' }}>End Date:</label>
                                <Calendar
                                    id="endDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.value)}
                                    placeholder="Select end date"
                                    dateFormat="dd/mm/yy"
                                    style={{ flex: 1, width: '150px' }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="d-flex align-items-center mb-3">
                                <label htmlFor="genre" style={{ width: '150px' }}>Genre:</label>
                                <MultiSelect
                                    id="genre"
                                    value={genre}
                                    onChange={(e) => setGenre(e.value)}
                                    options={genres}
                                    optionLabel="name"
                                    optionValue="value"
                                    placeholder="Select genre"
                                    style={{ flex: 1, width: '150px' }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="d-flex align-items-center mb-3">
                                <label htmlFor="language" style={{ width: '150px' }}>Language in Title:</label>
                                <MultiSelect
                                    id="language"
                                    value={language}
                                    onChange={(e) => setLanguage(e.value)}
                                    options={languages}
                                    optionLabel="name"
                                    placeholder="Select language"
                                    style={{ flex: 1, width: '150px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                <form onSubmit={handleIMDBFiltersSubmit}>
                    <br />
                    <Button
                        type="submit"
                        label="Extract"
                        icon="pi pi-save"
                        className="p-button-info mr-2"
                    />
                    {loading && (
                        <ProgressSpinner
                            style={{ width: '50px', height: '50px' }}
                            strokeWidth="8"
                            fill="var(--surface-ground)"
                            animationDuration=".5s"
                        />
                    )}
                </form>
            </TabPanel>
            <TabPanel header="Standardize Excel">
                <div className="grid">
                    <div className="col-12">

                        <h6>Insert an XLSX file to obtain a standardized XLSX for input into the crawler</h6>

                        <form onSubmit={handleStandardizeXlsx}>
                            <input
                                type="file"
                                id="fileInputJustCrawler"
                                placeholder='Choose file'
                                onChange={handleFileChange}
                                accept=".xlsx, .xls"
                            />
                            <br />
                            <br />
                            <Button
                                type="submit"
                                label="Standardize"
                                icon="pi pi-save"
                                className="p-button-info mr-2"
                            />
                            {loading ?
                                <ProgressSpinner
                                    style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"
                                />
                                :
                                null
                            }
                        </form>
                    </div>
                </div>
            </TabPanel>
        </TabView>

    );
};

export default EmptyPage;
